import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Input,
  message,
  Checkbox,
} from "antd";
import { useEffect, useState } from "react";
import { handleUpdateRole } from "../../../api/matrix";


export default function UpdateRole({
  isVisible,
  setVisible,
  selectedRole,
}: any) {
  const [isReport, setReport] = useState<boolean>(false);
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const { mutate, isPending } = useMutation({
    mutationFn: handleUpdateRole,
    onSuccess: () => {
      message.success("Updated Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["roles"] });
    },
    onError: (error) => {
      message.error(`${error}`);
    },
  });

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const data = {
      isReport,
      ...values,
    };
    await mutate({ _id: selectedRole?._id, data });
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({ name: selectedRole?.name });
    form.setFieldsValue({ max: selectedRole?.max });
    form.setFieldsValue({ min: selectedRole?.min });
    setReport(selectedRole?.isReport);
  }, [selectedRole]);

  return (
    <Modal
      open={isVisible}
      title="Update Role"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="updateRole"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Update
        </Button>,
      ]}
    >
      <Form
        id="updateRole"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please enter name",
                },
              ]}
            >
              <Input type="text" placeholder="Name" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="min"
              label="Minimum Level"
              rules={[
                {
                  required: true,
                  message: "Please enter minimum level",
                },
              ]}
            >
              <Input
                type="number"
                step={1}
                min={1}
                placeholder="Minimum Level i.e 1"
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="max"
              label="Maximum Level"
              rules={[
                {
                  required: true,
                  message: "Please enter maximum level",
                },
              ]}
            >
              <Input
                type="number"
                step={1}
                min={1}
                placeholder="Maximum Level i.e 7"
              />
            </Form.Item>
          </Col>
        </Row>

        <Checkbox checked={isReport} onChange={() => setReport(!isReport)}>
          <div className="flex items-center">is report?</div>
        </Checkbox>
      </Form>
    </Modal>
  );
}
